export default "__VITE_ASSET__BvCcARgQ__"